import { createFileRoute } from '@tanstack/react-router'
import InvitePage from '@/pages/invite/InvitePage'
import { useDocumentTitle } from 'usehooks-ts'
import { APP_NAME } from '@/lib/env'
export const Route = createFileRoute('/(auth)/invite')({
  component: RouteComponent,
})

function RouteComponent() {
  useDocumentTitle(`Invite - ${APP_NAME}`)
  return <InvitePage />
}
